let text = {
  homepageText: "WE ARE SELFLESS FAMILY",
  hintText: "YOUR DREAM IS OUR DREAM",
};
export default text;
